<div
  class="shop-menu-nav-item-wrapper"
  [class.expanded]="expanded"
  [class.active]="item.active"
  [class.has-sub-items]="hasSubItems"
>
  <div class="shop-menu-nav-item-header">
    <button
      box-button
      size="small"
      theme="insignificant"
      [attr.aria-label]="item.name | translate"
      [attr.aria-pressed]="item.active"
      (click)="onSelectItem($event)"
      class="shop-menu-nav-item-header-text"
    >
      {{ item.name | translate }}
    </button>
    <div *ngIf="!disableToggle" class="shop-menu-nav-item-header-chevron-wrapper">
      <button
        *ngIf="hasSubItems"
        mat-icon-button
        class="shop-menu-nav-item-header-chevron"
        (click)="onChevronClick($event)"
        [attr.aria-label]="expanded ? 'Collapse ' + (item.name | translate) : 'Expand ' + (item.name | translate)"
        [attr.aria-expanded]="expanded"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
  <ul *ngIf="hasSubItems && expanded" class="shop-menu-nav-item-list" [attr.id]="'subitems-' + item._id" role="list">
    @for (subItem of item.subItems; track subItem._id) {
      <li>
        <button
          box-button
          size="small"
          theme="insignificant"
          (click)="onSelectItem($event, subItem)"
          [attr.aria-pressed]="subItem.active"
          [class.active]="subItem.active"
          class="shop-menu-nav-item-list-item"
        >
          {{ subItem.name }}
        </button>
      </li>
    }
  </ul>
</div>
